import { Injectable } from '@angular/core';
import { CustomerAccountingImportDTO, CustomerAccountingInfo, PagedRequest, PagedResponse } from './model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerAccountingService {

  constructor(private http: HttpClient) { }

  list(req: PagedRequest): Observable<PagedResponse<CustomerAccountingImportDTO>> {
    return this.http.post<PagedResponse<CustomerAccountingImportDTO>>(
      `${environment.apiUrl}/Admin/CustomerAccountingImports/List`, req);
  }

  import(file: FormData): Observable<void> {
    console.log(file);
    return this.http.post<void>(
      `${environment.apiUrl}/Admin/CustomerAccountingImports/Import`, file); //, data: { Date: date }
  }

  get(date: Date): Observable<CustomerAccountingInfo[]> {
    const dateStr = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    return this.http.get<CustomerAccountingInfo[]>(
      `${environment.apiUrl}/Admin/CustomerAccountingImports/Get/${dateStr}`);
  }

  deleteAll(date: Date): Observable<CustomerAccountingInfo[]> {
    const dateStr = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    return this.http.get<CustomerAccountingInfo[]>(
      `${environment.apiUrl}/Admin/CustomerAccountingImports/Delete/${dateStr}`);
  }

  delete(id: number): Observable<void> {
    return this.http.get<void>(
      `${environment.apiUrl}/Admin/CustomerAccountingImports/DeleteOne/${id}`);
  }

  sendEmails(date: Date): Observable<CustomerAccountingInfo[]> {
    const dateStr = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    return this.http.get<CustomerAccountingInfo[]>(
      `${environment.apiUrl}/Admin/CustomerAccountingImports/SendEmails/${dateStr}`);
  }

  sendEmail(id: number): Observable<CustomerAccountingInfo[]> {
    return this.http.get<CustomerAccountingInfo[]>(
      `${environment.apiUrl}/Admin/CustomerAccountingImports/SendEmail/${id}`);
  }

  sendTestEmail(id: number, email: string): Observable<void> {
    return this.http.post<void>(
      `${environment.apiUrl}/Admin/Notifications/TestSend`, { id: id, email: email });
  }

  previewNotification(id: number): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/Admin/Notifications/Preview/${id}`);
  }

  updateNotificationContent(data: NotificationCustomDataDto): Observable<void> {
    return this.http.post<void>(
      `${environment.apiUrl}/Admin/CustomerAccountingImports/UpdateNotificationContent`, data);
  }
}

export interface NotificationCustomDataDto {
  id: number;
  to: string;
  cc: string;
  subject: string;
  body: string;
}
